import { createUpsell } from '../upsell';
export const yeLWMM = createUpsell({
    id: 'yeLWMM',
    desc: 'Upsell sequence for RH coach with conditional logic - EU',
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: ['upsell-sweet-treats', 'upsell-detox', 'upsell-fast-food', 'upsell-alcohol'],
            onDecline: ['upsell-12-month', 'upsell-sweet-treats', 'upsell-detox', 'upsell-fast-food', 'upsell-alcohol'],
        },
    ],
});
